import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const LangRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Swatches = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const Angles = styled.div`
    display: flex;
    gap: 8px;
`;

// Превью на сером фоне: белую плашку на белой карточке иначе не видно.
export const Preview = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-radius: ${radii.order};
    background: ${colors.segmentBg};
`;
